module.exports = __webpack_public_path__ + "img/pie_s_chart.5cab282a.svg";